// ============================================================================
// EmployeeTabRoute — guard de rota por ABA (agnóstico ao nome do cargo)
// ----------------------------------------------------------------------------
// Permite montar QUALQUER página (inclusive componentes do Master) numa rota de
// colaborador, liberando o acesso apenas se a aba correspondente estiver
// configurada para o cargo do usuário (employee_types.tabs). Assim reusamos as
// telas do Master sem precisar de guard interno em cada componente.
//
// Uso:
//   <EmployeeTabRoute tabKey="drafts">
//     <MasterDrafts />
//   </EmployeeTabRoute>
// ============================================================================
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useTabAccess } from "../hooks/useRoleTabs";
import { useActiveCargo } from "../lib/activeCargo";
import { permsForRole } from "../lib/roles";

const EmployeeTabRoute = ({ tabKey, children }) => {
  const { user, loading } = useAuth();
  const { activeCargo } = useActiveCargo();
  const cargo = activeCargo || user?.employeeRole;
  const access = useTabAccess(cargo, tabKey, permsForRole(user, cargo));

  if (loading || access.status === "loading") return null;
  // Aba não liberada -> primeira aba do cargo; cargo sem abas -> Meus Arquivos.
  if (access.status === "redirect") {
    return <Navigate to={access.redirectTo} replace />;
  }
  if (access.status === "empty") {
    return <Navigate to="/employee/files" replace />;
  }
  return children;
};

export default EmployeeTabRoute;
